"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReportType = exports.isReceivablesSaleAgreementReportingGenerateQaWorkleaseConfig = exports.isReceivableResponseTapePreviewReportingGenerateQaWorkleaseConfig = exports.isInvoiceReportingGenerateQaWorkleaseConfig = exports.isFundingRequestReportingGenerateQaWorkleaseConfig = exports.isBorrowingBaseServicerReportingGenerateQaWorkleaseConfig = exports.isReportingGenerateWorkleaseStatusParameterMetadata = exports.isReportingGenerateFailureWorklease = exports.isReportingGenerateCompleteWorklease = exports.isReportingXslx2CsvEvaluateWorklease = exports.isReportingGenerateEvaluateWorklease = exports.isReportingXlsx2CsvWorklease = exports.isReportingGenerateWorklease = void 0;
const schema = __importStar(require("../schema"));
const Log_1 = require("../types/Log");
const Report_1 = require("../types/Report");
const typeguardUtils_1 = require("./typeguardUtils");
exports.isReportingGenerateWorklease = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReportingGenerateWorkleaseSchema,
    typeguardName: 'isReportingGenerateWorklease',
});
exports.isReportingXlsx2CsvWorklease = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReportingXlsx2CsvWorkleaseSchema,
    typeguardName: 'isReportingXlsx2CsvWorklease',
});
exports.isReportingGenerateEvaluateWorklease = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReportingGenerateEvaluateWorkleaseSchema,
    typeguardName: 'isReportingGenerateEvaluateWorklease',
});
exports.isReportingXslx2CsvEvaluateWorklease = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReportingXslx2CsvEvaluateWorkleaseSchema,
    typeguardName: 'isReportingXslx2CsvEvaluateWorklease',
});
exports.isReportingGenerateCompleteWorklease = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReportingGenerateCompleteWorkleaseSchema,
    typeguardName: 'isReportingGenerateCompleteWorklease',
});
exports.isReportingGenerateFailureWorklease = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReportingGenerateFailureWorkleaseSchema,
    typeguardName: 'isReportingGenerateFailureWorklease',
});
exports.isReportingGenerateWorkleaseStatusParameterMetadata = (0, typeguardUtils_1.typeguardFunctionWrapper)(schema.ReportingGenerateWorkleaseStatusParameterMetadataSchema);
exports.isBorrowingBaseServicerReportingGenerateQaWorkleaseConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.BorrowingBaseServicerReportingGenerateQaWorkleaseConfigSchema,
    typeguardName: 'isBorrowingBaseServicerReportingGenerateQaWorkleaseConfig',
});
exports.isFundingRequestReportingGenerateQaWorkleaseConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.FundingRequestReportingGenerateQaWorkleaseConfigSchema,
    typeguardName: 'isFundingRequestReportingGenerateQaWorkleaseConfig',
});
exports.isInvoiceReportingGenerateQaWorkleaseConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.InvoiceReportingGenerateQaWorkleaseConfig,
    typeguardName: 'isInvoiceReportingGenerateQaWorkleaseConfig',
});
exports.isReceivableResponseTapePreviewReportingGenerateQaWorkleaseConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReceivableResponseTapePreviewReportingGenerateQaWorkleaseConfigSchema,
    typeguardName: 'isReceivableResponseTapePreviewReportingGenerateQaWorkleaseConfig',
});
exports.isReceivablesSaleAgreementReportingGenerateQaWorkleaseConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReceivablesSaleAgreementReportingGenerateQaWorkleaseConfigSchema,
    typeguardName: 'isReceivablesSaleAgreementReportingGenerateQaWorkleaseConfig',
});
const isReportType = (obj, logOptions) => {
    let errorMessage = '';
    if (typeof obj !== 'string') {
        errorMessage = 'ReportType typeguard failed: input is not a string';
    }
    else if (!Report_1.ReportTypeIterable.some((type) => type === obj)) {
        errorMessage = `ReportType typeguard failed: ${obj} is not ReportType option`;
    }
    if (errorMessage && logOptions?.logger) {
        logOptions.logger({ message: errorMessage }, logOptions.logLevel || Log_1.LogLevel.Error);
    }
    return errorMessage.length === 0;
};
exports.isReportType = isReportType;
//# sourceMappingURL=reporting.js.map